export enum MASTER_VIEW_KEY {
  ASSETS = 'assets',
  ASSET_EVENTS = 'asset-events',
  DEVICES = 'devices',
  DEVICE_EVENTS = 'device-events',
  SITES = 'sites'
}
